// ======================================================================
// File Name       : userAttribute
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { SELECT_TARGET_DATA } from '../../constants';

export function postUserAttributeGetList(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };

  return commonCallApi({
    path: 'userAttribute/GetList',
    data: { ...PARAM_DEFAULT, ...data },
  });
}

export function postUserAttributeEdit(data) {
  return commonCallApi({
    path: 'userAttribute/Edit',
    data,
  });
}
